export default class MapPlant {
  /**
   * Represent a planted zone, in the garden (circle, polygon, point).
   *
   * MapPlants have a geoJSON data attribute which specify the type of
   * areas (a point represent a single plant, circles and polygons represents
   * areas where plant is planted.
   *
   * @param id {number} Unique identifier
   * @param name {String} Optional name (i.e.: 'My carrot patch', 'Shadowed rose')
   * @param mapId {number} Unique map identifier
   * @param plantId {number} Identifier of the Plant type
   * @param plantationDate {Date}
   * @param geoJson {Object|String} Data to transpose the plant on the map
   */
  constructor ({ id, name, mapId, plantId, plantationDate, geoJson }) {
    this.id = id
    this.name = name
    this.mapId = mapId
    this.plantId = plantId
    this.plantationDate = new Date(plantationDate)

    if ((typeof geoJson) === 'string') {
      this.geoJson = JSON.parse(geoJson)
    } else {
      this.geoJson = geoJson
    }
  }

  isCircle () {
    return this.geoJson.properties &&
      this.geoJson.properties.radius &&
      (typeof this.geoJson.properties.radius) === 'number' &&
      this.geoJson.geometry.type === 'Point'
  }

  isPoint () {
    return !this.isCircle() && this.geoJson.geometry.type === 'Point'
  }

  getType () {
    if (this.isCircle()) return 'Circle'
    else return this.geoJson.geometry.type
  }
}
